import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";
import { TEMPLATE_GROUP_TYPES } from "enums";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    logo: PropTypes.string,
    video: PropTypes.string,
    image: PropTypes.string,
    backgroundColor: PropTypes.string,
    backgroundGradientBottomColor: PropTypes.string,
    link: PropTypes.string,
  },
  {
    posterUrl(customContentType) {
      return this.image(customContentType);
    },
    titleImage(customContentType) {
      return this.logo(customContentType);
    },
    previewVideo(customContentType) {
      return this.video(customContentType);
    },
    analyticsItem(customContentType) {
      return {
        item_id: this.id(customContentType),
        item_name: this.name(customContentType),
      };
    },
    templateGroupType() {
      return TEMPLATE_GROUP_TYPES.customContentType;
    },
  },
);
